import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

// import {
//   C11nYouTubePlayer,
//   C11nYouTubePlayerLiteral,
//   YouTubePlayerComponent,
// } from '@vg-constellation/web/youtube-player'
import { PaginationComponent } from './components/pagination/pagination.component'
import { RiskScaleComponent } from './components/risk-scale/risk-scale.component'
import { ConstellationModule } from './constellation.module'
import { ScrollingTableDirective } from './directives/scrolling-table.directive'
import { AmountPipe } from './pipes/amount.pipe'
import { DashIfEmpty } from './pipes/dash-if-empty.pipe'
import { DaysPipe } from './pipes/days.pipe'
import { EmDashPipe } from './pipes/em-dash.pipe'
import { ESTPipe } from './pipes/est.pipe'
import { OverflowPipe } from './pipes/overflow.pipe'
import { PercentagePipe } from './pipes/percentage.pipe'
import { PortfolioHoldingsSortPipe } from './pipes/portfolio-holdings-sort.pipe'
import { SanitizeHtmlPipe } from './pipes/sanitizeHtml.pipe'
import { TrimPipe } from './pipes/trim.pipe'
import { ValueChangePipe } from './pipes/value-change.pipe'
import { VmfPercentPipe } from './pipes/vmf-percent.pipe'

@NgModule({
  declarations: [
    VmfPercentPipe,
    DashIfEmpty,
    RiskScaleComponent,
    EmDashPipe,
    PercentagePipe,
    AmountPipe,
    PortfolioHoldingsSortPipe,
    ESTPipe,
    DaysPipe,
    ScrollingTableDirective,
    SanitizeHtmlPipe,
    OverflowPipe,
    TrimPipe,
    PaginationComponent,
    ValueChangePipe,
  ],
  imports: [CommonModule, ConstellationModule],
  exports: [
    VmfPercentPipe,
    DashIfEmpty,
    RiskScaleComponent,
    EmDashPipe,
    PercentagePipe,
    AmountPipe,
    PortfolioHoldingsSortPipe,
    ESTPipe,
    DaysPipe,
    ScrollingTableDirective,
    SanitizeHtmlPipe,
    OverflowPipe,
    TrimPipe,
    PaginationComponent,
    ConstellationModule,
    ValueChangePipe,
  ],
})
export class SharedModule {}
